// /**
//  * Scrolling Images JavaScript
//  * Handles scroll-based horizontal movement of images
//  */

// class ScrollingImages {
//     constructor(element) {
//       this.element = element;
//       this.track = element.querySelector('.tpt-scrolling-images_track');
//       this.scrollMultiplier = parseFloat(element.dataset.scrollMultiplier) || 0.5;
      
//       this.lastScrollY = window.pageYOffset;
//       this.currentTranslateX = 0;
//       this.isScrolling = false;
//       this.scrollTimeout = null;
//       this.trackWidth = 0;
//       this.containerWidth = 0;
      
//       this.init();
//     }
  
//     init() {
//       this.calculateDimensions();
//       this.bindEvents();
      
//       // Initial setup
//       this.updateTransform();
//     }
  
//     calculateDimensions() {
//       if (!this.track) return;
      
//       const items = this.track.querySelectorAll('.tpt-scrolling-images_item:not(.tpt-scrolling-images_duplicate)');
//       if (items.length === 0) return;
      
//       // Calculate total width of original items
//       let totalWidth = 0;
//       items.forEach(item => {
//         totalWidth += item.offsetWidth;
//       });
      
//       // Add spacing between items
//       const computedStyle = getComputedStyle(this.track);
//       const gap = parseFloat(computedStyle.gap) || 0;
//       totalWidth += gap * (items.length - 1);
      
//       this.trackWidth = totalWidth;
//       this.containerWidth = this.element.offsetWidth;
//     }
  
//     bindEvents() {
//       // Scroll event with throttling
//       let ticking = false;
      
//       window.addEventListener('scroll', () => {
//         if (!ticking) {
//           requestAnimationFrame(() => {
//             this.handleScroll();
//             ticking = false;
//           });
//           ticking = true;
//         }
//       }, { passive: true });
  
//       // Resize event
//       window.addEventListener('resize', this.debounce(() => {
//         this.calculateDimensions();
//       }, 250));
  
//       // Intersection Observer to pause when out of view
//       if ('IntersectionObserver' in window) {
//         const observer = new IntersectionObserver((entries) => {
//           entries.forEach(entry => {
//             if (entry.isIntersecting) {
//               this.element.classList.add('in-view');
//             } else {
//               this.element.classList.remove('in-view');
//             }
//           });
//         }, { threshold: 0.1 });
  
//         observer.observe(this.element);
//       }
//     }
  
//     handleScroll() {
//       if (!this.element.classList.contains('in-view')) return;
      
//       const currentScrollY = window.pageYOffset;
//       const scrollDelta = currentScrollY - this.lastScrollY;
      
//       // Update scroll state
//       this.isScrolling = true;
//       this.track.classList.remove('smooth-scroll');
      
//       // Clear existing timeout
//       if (this.scrollTimeout) {
//         clearTimeout(this.scrollTimeout);
//       }
      
//       // Calculate movement based on scroll direction and speed
//       const movement = scrollDelta * this.scrollMultiplier;
//       this.currentTranslateX -= movement; // Negative for right-to-left when scrolling down
      
//       // Create infinite loop effect
//       if (this.currentTranslateX <= -this.trackWidth) {
//         this.currentTranslateX = 0;
//       } else if (this.currentTranslateX > 0) {
//         this.currentTranslateX = -this.trackWidth;
//       }
      
//       this.updateTransform();
      
//       // Set timeout to stop scrolling state
//       this.scrollTimeout = setTimeout(() => {
//         this.isScrolling = false;
//         this.track.classList.add('smooth-scroll');
//       }, 150);
      
//       this.lastScrollY = currentScrollY;
//     }
  
//     updateTransform() {
//       if (!this.track) return;
      
//       // Apply transform with hardware acceleration
//       this.track.style.transform = `translate3d(${this.currentTranslateX}px, 0, 0)`;
//     }
  
//     // Utility function for debouncing
//     debounce(func, wait) {
//       let timeout;
//       return function executedFunction(...args) {
//         const later = () => {
//           clearTimeout(timeout);
//           func(...args);
//         };
//         clearTimeout(timeout);
//         timeout = setTimeout(later, wait);
//       };
//     }
//   }
  
//   // Initialize when DOM is ready
//   document.addEventListener('DOMContentLoaded', () => {
//     const scrollingImagesSections = document.querySelectorAll('.tpt-scrolling-images');
    
//     scrollingImagesSections.forEach(section => {
//       new ScrollingImages(section);
//     });
//   });
  
//   // Handle dynamic content loading (for theme editor)
//   document.addEventListener('shopify:section:load', (event) => {
//     const section = event.target.querySelector('.tpt-scrolling-images');
//     if (section) {
//       new ScrollingImages(section);
//     }
//   });
  
//   // Cleanup on section unload
//   document.addEventListener('shopify:section:unload', (event) => {
//     // Cleanup would go here if needed
//     // For now, event listeners will be cleaned up automatically when elements are removed
//   });
  
//   // Performance optimization: Reduce motion for users who prefer it
//   if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
//     document.documentElement.style.setProperty('--scroll-speed', '0');
//   }

/**
 * Scrolling Images JavaScript
 * Handles scroll-based horizontal movement of images
 */

class ScrollingImages {
    constructor(element) {
      this.element = element;
      this.track = element.querySelector('.tpt-scrolling-images_track');
      this.scrollMultiplier = parseFloat(element.dataset.scrollMultiplier) || 0.5;
      
      this.lastScrollY = window.pageYOffset;
      this.currentTranslateX = 0;
      this.targetTranslateX = 0;
      this.isScrolling = false;
      this.scrollTimeout = null;
      this.trackWidth = 0;
      this.containerWidth = 0;
      
      // Add smoothing variables
      this.scrollHistory = [];
      this.maxScrollDelta = 10; // Maximum movement per frame
      this.smoothingFactor = 0.8;
      
      this.init();
    }
  
    init() {
      this.calculateDimensions();
      this.bindEvents();
      this.startAnimationLoop();
      
      // Initial setup
      this.updateTransform();
    }
  
    calculateDimensions() {
      if (!this.track) return;
      
      const items = this.track.querySelectorAll('.tpt-scrolling-images_item:not(.tpt-scrolling-images_duplicate)');
      if (items.length === 0) return;
      
      // Calculate total width of original items
      let totalWidth = 0;
      items.forEach(item => {
        totalWidth += item.offsetWidth;
      });
      
      // Add spacing between items
      const computedStyle = getComputedStyle(this.track);
      const gap = parseFloat(computedStyle.gap) || 0;
      totalWidth += gap * (items.length - 1);
      
      this.trackWidth = totalWidth;
      this.containerWidth = this.element.offsetWidth;
    }
  
    bindEvents() {
      // Scroll event with throttling
      let ticking = false;
      
      window.addEventListener('scroll', () => {
        if (!ticking) {
          requestAnimationFrame(() => {
            this.handleScroll();
            ticking = false;
          });
          ticking = true;
        }
      }, { passive: true });
  
      // Resize event
      window.addEventListener('resize', this.debounce(() => {
        this.calculateDimensions();
      }, 250));
  
      // Intersection Observer to pause when out of view
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.element.classList.add('in-view');
            } else {
              this.element.classList.remove('in-view');
            }
          });
        }, { threshold: 0.1 });
  
        observer.observe(this.element);
      }
    }
  
    handleScroll() {
      if (!this.element.classList.contains('in-view')) return;
      
      const currentScrollY = window.pageYOffset;
      let scrollDelta = currentScrollY - this.lastScrollY;
      
      // Store scroll history for smoothing
      this.scrollHistory.push(scrollDelta);
      if (this.scrollHistory.length > 3) {
        this.scrollHistory.shift();
      }
      
      // Calculate smoothed scroll delta
      const avgScrollDelta = this.scrollHistory.reduce((sum, delta) => sum + delta, 0) / this.scrollHistory.length;
      
      // Limit the maximum movement per frame to prevent excessive speed
      const clampedDelta = Math.max(-this.maxScrollDelta, Math.min(this.maxScrollDelta, avgScrollDelta));
      
      // Update scroll state
      this.isScrolling = true;
      this.track.classList.remove('smooth-scroll');
      
      // Clear existing timeout
      if (this.scrollTimeout) {
        clearTimeout(this.scrollTimeout);
      }
      
      // Calculate movement based on scroll direction and speed
      const movement = clampedDelta * this.scrollMultiplier;
      this.targetTranslateX -= movement; // Negative for right-to-left when scrolling down
      
      // Create infinite loop effect with smoother transitions
      this.normalizeTranslateX();
      
      // Set timeout to stop scrolling state
      this.scrollTimeout = setTimeout(() => {
        this.isScrolling = false;
        this.track.classList.add('smooth-scroll');
        this.scrollHistory = []; // Clear history when scrolling stops
      }, 150);
      
      this.lastScrollY = currentScrollY;
    }
  
    normalizeTranslateX() {
      // Smooth infinite loop without sudden jumps
      if (this.targetTranslateX <= -this.trackWidth) {
        this.targetTranslateX += this.trackWidth;
      } else if (this.targetTranslateX > 0) {
        this.targetTranslateX -= this.trackWidth;
      }
    }
  
    startAnimationLoop() {
      const animate = () => {
        // Smooth interpolation between current and target position
        const diff = this.targetTranslateX - this.currentTranslateX;
        this.currentTranslateX += diff * this.smoothingFactor;
        
        // Stop interpolation when very close to target
        if (Math.abs(diff) < 0.01) {
          this.currentTranslateX = this.targetTranslateX;
        }
        
        this.updateTransform();
        requestAnimationFrame(animate);
      };
      
      requestAnimationFrame(animate);
    }
  
    updateTransform() {
      if (!this.track) return;
      
      // Apply transform with hardware acceleration
      this.track.style.transform = `translate3d(${this.currentTranslateX}px, 0, 0)`;
    }
  
    // Utility function for debouncing
    debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }
  }
  
  // Initialize when DOM is ready
  document.addEventListener('DOMContentLoaded', () => {
    const scrollingImagesSections = document.querySelectorAll('.tpt-scrolling-images');
    
    scrollingImagesSections.forEach(section => {
      new ScrollingImages(section);
    });
  });
  
  // Handle dynamic content loading (for theme editor)
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.tpt-scrolling-images');
    if (section) {
      new ScrollingImages(section);
    }
  });
  
  // Cleanup on section unload
  document.addEventListener('shopify:section:unload', (event) => {
    // Cleanup would go here if needed
    // For now, event listeners will be cleaned up automatically when elements are removed
  });
  
  // Performance optimization: Reduce motion for users who prefer it
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.documentElement.style.setProperty('--scroll-speed', '0');
  }